export default __webpack_public_path__ + "static/media/how-work-img-02.811e75e5.svg";